class ProductModal extends ModalDialog {
  constructor () {
    super()
  }

  hide () {
    super.hide()
  }

  show (opener) {
    super.show(opener)
    this.showActiveMedia()
  }

  showActiveMedia () {
    const activeMediaId = this.openedBy.dataset.mediaId
    const modalImages = Array.from(this.querySelectorAll('[data-media-id]'))

    if (!activeMediaId) return

    const activeMedia = modalImages.filter(el => el.dataset.mediaId === activeMediaId)
    activeMedia[0].scrollIntoView()
    const sliderTrack = this.querySelector('.product-media-modal__list')

    if (!sliderTrack) return

    sliderTrack.scrollTo({
      left: activeMedia[0].offsetLeft,
      behavior: 'instant',
    })
  }
}

customElements.define('product-modal', ProductModal)
